import {
  Component,
  OnInit
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  Validators
} from '@angular/forms';
import {
  BsModalRef
} from 'ngx-bootstrap/modal';
import {
  ObjectUtils
} from 'src/app/@core/utils/object-utils';
import {
  OnbaseService
} from 'src/app/services/onbase.service';

@Component({
  selector: 'app-pos-credit-request-company-banking-references-modal',
  templateUrl: './pos-credit-request-company-banking-references-modal.component.html',
  styleUrls: ['./pos-credit-request-company-banking-references-modal.component.sass']
})
export class PosCreditRequestCompanyBankingReferencesModalComponent implements OnInit {

  relationshipTypes
    : Array<{
      key: string,
      value: string
    }> = [];
  constructor(private bsModalRef: BsModalRef, private onbaseService: OnbaseService) {

  }
  confirmAction: (form: FormGroup) => any = () => { };
  async ngOnInit(): Promise<void> {
    let onbaseCatalogue = (await this.onbaseService.readOnBaseCatalogue().toPromise()).response;
    this.relationshipTypes
      = ObjectUtils.objectToArray(onbaseCatalogue.businessPosition);
  }

  form: FormGroup = new FormGroup({
    name: new FormControl("", Validators.required),
    institutionName: new FormControl("", Validators.required),
    relationshipInitialDate: new FormControl("", Validators.required),
    phone: new FormControl("", Validators.required),
    phoneExtension: new FormControl(""),
    relationshipType: new FormControl("", Validators.required),
  });

  confirm() {
    this.confirmAction(this.form);
    this.close();
  }

  close() {
    this.bsModalRef.hide();
  }

  draft() {
    this.confirmAction(this.form);
    this.close();
  }

}
